import ProductApi from "@/services/api/productApi";
import { mapGetters } from "vuex";

const ProductApiService = new ProductApi();

export default {
  data() {
    return {
      request_started: false,
      csv: null,
      success: false,
      error: false,
      selectedBrand: null,
      isBrandsFetched: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "userState",
    }),
  },
  methods: {
    close,
    triggerInputFile,
    onInputFileChange,
    addDroppedFile,
    submitFile,
    removeFile,
    submit,
    isAdminOrProductBuilder,
    brandsFetched,
    showDropZone,
    brandChangeCallback,
  },
};

function close() {
  this.$emit("close-import-products-modal");
}

function triggerInputFile() {
  this.$refs.csvImportInput.click();
}

function addDroppedFile(event) {
  const dataTransfer = event.dataTransfer,
    files = dataTransfer.files;
  this.submitFile(files[0]);
}

function onInputFileChange(event) {
  if (!event.target.files.length) {
    return;
  }

  const file = event.target.files[0];
  this.submitFile(file);
}

function submitFile(file) {
  if (file.size > this.$utils.getByteSizeFromMegabyteSize(this.$utils.constants.CSV_UPLOAD_SIZE_LIMIT_MB)) {
    this.removeFile();
    return this.$swal({
      title: this.$utils.constants.CSV_UPLOAD_SIZE_LIMIT_ERROR_MESSAGE,
    });
  }

  const { type } = file;
  if (!this.$utils.constants.ACCEPTED_CSV_MIME_TYPES.includes(type)) {
    this.removeFile();
    return this.$swal("Attention", "Please upload a .csv file.");
  }

  if (this.isAdminOrProductBuilder() && !this.selectedBrand) {
    this.removeFile();
    return this.$swal("Attention", "Please select a Brand.");
  }

  this.csv = file;
  this.$refs.csvImportInput.value = "";
  this.submit();
}

function removeFile() {
  this.csv = null;
  this.$refs.csvImportInput.value = "";
}

function submit() {
  this.error = false;
  this.success = false;
  this.$loader.$emit("trigger", true);
  this.request_started = true;

  const formData = new FormData();
  formData.append("csvFile", this.csv, `product_import_${new Date()}.csv`);

  ProductApiService.importFromCSV(formData, this.selectedBrand?.id)
    .then(() => {
      if (this.$store.getters.draftStatus.error) {
        // this.error = "We could not read file you provided. Please try again with different file.";
        this.error = this.$store.getters.draftStatus.error;
        this.$store.commit("resetDraftError");
      } else {
        this.$store.commit("draftUploadStart");

        let route = "/dashboard/for-review";
        if (this.selectedBrand) {
          route = `${route}?brandId=${this.selectedBrand.id}&brandName=${this.selectedBrand.name}`;
        }

        this.$router.push(route);
      }
    })
    .catch((error) => {
      this.$bugsnagClient.notify(new Error(error));
      if (error.response) {
        this.error = error.response.data.error_message;
      } else {
        this.error = "We could not read file you provided. Please try again with different file.";
      }
    })
    .finally(() => {
      this.request_started = false;
      this.$loader.$emit("trigger", false);
      this.$store.dispatch("getDraftCount");
    });
}

function isAdminOrProductBuilder() {
  return this.user?.role === "ADMIN" || this.user?.role === "PRODUCT_BUILDER";
}

function brandChangeCallback(value) {
  this.selectedBrand = value;
}

function brandsFetched() {
  this.isBrandsFetched = true;
}

function showDropZone() {
  if (this.user.role === "BRAND") {
    return true;
  }

  if (this.isAdminOrProductBuilder()) {
    return this.isBrandsFetched;
  }

  return false;
}
